import AddSeat from "/@/views/Seat/components/addSeat.vue";

export default {
  router: {
    login: {
      title: "跨境客服云助手",
      text01: "双向实时翻译显示，多条翻译路线",
      text02: "覆盖全球 200+ 语言支持",
      text03: "Chatgpt,Deepl，最智能最准确 的翻译服务",
      text04: "手机端指纹浏览器模拟登录，轻松实现 一机账号多开",
      text05: "用户标签，精准管理，精确营销，一步到位",
      text06: "会话独立翻译设置，多国好友轻松聊；",
      useName: "账号登录",
      placeholder01: "请输入坐席账号",
      placeholder02: "请输入密码",
      loginText: "登 录",
      loginSuccess: "登录成功",
      protocol: "隐私协议",
    },
    head: {
      portNumber: "端口数",
      timeRemaining: "剩余时间",
      day: "天",
      Due: "已到期，请及时续费",
      expirationDate: "到期日期",
      service: "联系客服",
      help: "帮助",
      logout: "退出登录",
    },
    menu: {
      chat: "社媒账号聊天",
      seat: "坐席客服",
    },
    status: {
      all: "全部",
      Online: "在线",
      Offline: "离线",
      invoke: "启用",
      disabled: "禁用",
    },
    chat: {
      tableFields01: "账号",
      tableFields02: "归属社媒平台",
      tableFields03: "在线状态",
      tableFields04: "归属坐席(备注)",
      tableFields05: "头像",
      tableFields06: "昵称",
      tableFields07: "创建时间",
      tableFields08: "绑定坐席",
      tableFields09: "账号日志",
      socialAccounts: "社媒账号",
      socialAccountsName: "社媒账号昵称",
      addAccount: "添加社媒账号",
      updateSeat: "更换坐席",
      bindSeat: "绑定坐席",
      forcedOffline: "强制下线",
      delAccount: "账号删除",
      login: "登录",
      accountLog01: "实时日志记录",
      accountLog02: "当前",
      accountLog03: "条记录，最多显示近100条记录",
      qrCodeTitle: "点击可重新加载二维码",
      phone: "使用电话号码关联",
      verify01: "坐席客服不能为空",
      accountConnection: "账号连接中",
    },
    seat: {
      title: "坐席管理",
      addSeatButton: "新增坐席",
      editSeatButton: "编辑坐席",
      tableText01: "坐席账号",
      tableText02: "已分配社媒账号",
      tableText03: "在线状态",
      tableText04: "账号状态",
      tableText05: "备注",
      tableText06: "添加时间",
      tableText07: "坐席密码",
      bindSocialMediaAccount: "绑定社媒账号",
      automatic: "提交后自动生成",
      seatPassword: "坐席密码",
      enable: "是否启用",
      placeholder01: "请输入账号",
      placeholder02: "请输入备注",
      placeholder03: "请输入密码",
      passwordVerification: "密码不能为空",
      passwordLengthVerification: "密码最小长度不能小于4，最大长度不能大于10",
      selectAccount: "选择账号",
    },
    public: {
      inputText: "请输入",
      selsectText: "请选择",
      query: "查询",
      reset: "重置",
      check: "查看",
      operate: "操作",
      status: "状态",
      edit: "编辑",
      confirm: "确 定",
      cancel: "取 消",
    },
    message: {
      delTitle: "删除标签",
      delHint: "确定要删除吗？",
      OfflineTitle: "下线标签",
      OfflineHint: "确定要强制下线吗？",
      delSuccess: "删除成功",
      editSuccess: "编辑成功",
      addSuccess: "创建成功",
      acountEmptyWarning: "账号不能为空",
      accountAlreadyExistsAndOnline: "登录失败，该社媒账号已登录",
      account_already_and_implemented_online:
        "登录成功，非当前记录社媒账号，请在列表中查询",
      social_account_state: "登录中...，请稍后",
    },
    language: {
      zh_cn: "中文",
      en: "英语",
    },
  },
};
